module.exports = __webpack_public_path__ + "img/type10030.2e447f85.png";